import { APIDelete, APIGet, APIPost } from '../../../API';
import React, { useContext, useEffect, useState } from 'react';
import { T } from '../../../traks';
import LinkCopy from '../../../c/LinkCopy';
import MeContext from '../../../MeContext';
import { Loading } from '../../../c/Loading';
import { RenderIf } from '../../../helpers/RenderIf';
import { AlertModal } from '../../../c/Modals';
import { ContentHeader } from '../DashboardPage';
import { Col, Container, Row } from 'reactstrap';

const NoLinks = () => {
	return (
		<div className="text-center">
			<img src="https://static.sibilus.eu/gfx/link_image-0.svg" className="w-30" alt='our logo' />
			<div className="primary fs-4 mt-5">
				<T>There is no links created for sumitting entries</T>
			</div>
			<div className="light-grey-text">
				<T>Make sure your link is active</T>
				<br />
				<T>so your colleagues are able to file a case</T>
			</div>
		</div>
	)
}

const LinkList = ({ links, handleDeleteLink, handleDeactivateLink = undefined, link }) => {
	return (<>
		<RenderIf condition={links !== undefined && !links.length && !link} >
			<NoLinks />
		</RenderIf>
		<RenderIf condition={links.length > 0} >
			{links.map((link, index) =>
				<div key={index + "li"}>
					<LinkCopy
						dataCy={`link-${index}`}
						pathId={link}
						key={index + "li"}
						handleDeleteLink={handleDeleteLink}
						handleDeactivateLink={handleDeactivateLink}
						link={"create-whistle"}
					/>
				</div>
			)}
		</RenderIf>
	</>)
};

const LinkGenerator = (props) => {
	const { me } = useContext(MeContext);
	const [link, setLink] = useState('');
	const [showHelpText, setShowHelpText] = useState(false);
	const [linkList, setLinkList] = useState(undefined);
	const [alertType, setAlertType] = useState({ type: "", text: "" })
	const [showAlert, setShowAlert] = useState(false)
	const [showLoading, setShowLoading] = useState(false)

	const createLink = () => {
		setShowLoading(true)
		APIPost('whistlelinks', { company_id: me.company_id }).then((res) => {
			setShowLoading(false)
			setLink(res.data.link);
		}).catch((err) => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
			console.log(err)
		});
	};

	const getLinks = () => {
		setShowLoading(true)
		APIGet('whistlelinks', { company_id: me.company_id }).then((res) => {
			setShowLoading(false)
			setLinkList(res.data.links);
			if (res.data["no_case_workers"]) {
				setShowHelpText(true);
			}
		}).catch((err) => {
			console.log(err)
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
		});
	};

	const deleteLink = (linkId) => {
		setShowLoading(true)
		APIDelete('whistlelinks/' + linkId).then((res) => {
			setShowLoading(false)
			setAlertType({ type: "success", text: "link deleted" })
			setShowAlert(true)
			setLinkList(linkList.filter(link => link !== linkId))
			if (linkId === link) setLink("")
		}).catch((err) => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
			console.log(err)
		});
	};
	const handleDeleteLink = (link) => {
		deleteLink(link)
	}

	useEffect(() => {
		getLinks();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [link]);

	if (!linkList) {
		return (<>
			<Loading
				showLoading={showLoading}
				inFront
			/>
		</>)
	}

	return (
		<>
			<ContentHeader>
				<T>Generate Link</T>
			</ContentHeader>
			<Container fluid>
				<Row>
					<Col style={{ maxWidth: "100rem" }}>
						<RenderIf condition={showHelpText}>
							<div className="text-center">
								In order to create links for entries, <br />you need to have at least one user with a case worker role.
								<br />Either create a user, or assign a case worker role to a user
							</div>
						</RenderIf>
						<RenderIf condition={!showHelpText && linkList !== undefined && !link}>
							<LinkList
								links={linkList}
								handleDeleteLink={handleDeleteLink}
								link={link}
							/>
						</RenderIf>
						<RenderIf condition={!showHelpText} >
							<div className="text-center mt-5">
								<button className="btn btn_green" data-cy="generateLink" onClick={createLink}>
									<T>Generate New Link</T>
								</button>
							</div>
						</RenderIf>
					</Col>
				</Row>
			</Container>
			<Loading
				showLoading={showLoading}
				inFront
				overlay
			/>
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={alertType.type}
				text={alertType.text}
			/>
		</>
	);
};

export default LinkGenerator;
